module.exports = {"DELIVERY_RANGES":"results","DELIVERY_RANGE":{"LOWER":"lower","UPPER":"upper"}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/packageDeliveryRanges.json
// module id = 1752
// module chunks = 1